import Wrapper from "../../../layout/Wrapper";
import LifeContractClameComponent from "../../../screens/contractControll/lifeContract/clame";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Management",
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<LifeContractClameComponent />
		</Wrapper>
	);
}